import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  Typography,
  Grid,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { FormProvider, useForm } from "react-hook-form";

import Loader from "../components/Loader/Loader";
import FormOperator from "../components/FormOperator/FormOperator";
import TravelCareItem from "../steps/Step3/molecules/TravelCareItem";
import CustomRadio from "../components/CustomRadio/CustomRadio";
import NextButton from "../components/NextButton/NextButton";
import TicketProtectionIcon from "../assets/img/ticket-protection.svg";
import TickIcon from "../assets/img/tick-care.svg";
import { travelCareData } from "../constants/travelCareData";
import useStyles from "../steps/Step3/styles";
import { getFormData, VIEW_FORM_BASE_URL } from "../api/api";
import Accreditation from "../components/Accreditation/Accreditation";

const ThirdStepViewPage = () => {
  const [apiData, setApiData] = useState({});
  const { token, priceQuoteId } = useParams();
  const classes = useStyles();

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      if(window.userData){
        setApiData(window.userData);
      }
    }

    return () => (mounted = false);
  }, []);

  const methods = useForm({
    shouldUnregister: false,
    defaultValues: apiData?.result,
    resolver: undefined,
    mode: "onChange",
  });

  return (
    <FormProvider {...methods}>
      <form style={{ paddingBottom: "50px", height: "100%" }}>
        <Grid container style={{ height: "100%" }}>
          {typeof apiData === "object" && Object.keys(apiData).length > 1 ? (
            <ThirdStepViewForm classes={classes} apiData={apiData} />
          ) : (
            <Grid container>
              <Grid item xs={12} className={classes.mainForm}>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  flexDirection="column"
                >
                  {typeof apiData === "string" ? (
                    <Typography variant="h2">{apiData}</Typography>
                  ) : (
                    <Loader />
                  )}
                </Box>
              </Grid>
            </Grid>
          )}
        </Grid>
      </form>
    </FormProvider>
  );
};

const ThirdStepViewForm = ({ classes, apiData }) => {
  const theme = useTheme();
  const show = useMediaQuery(theme.breakpoints.down("sm"));

  const selectedFlight = apiData?.priceQuotes.find(
    (item) => item.id == apiData?.result?.flight
  );

  if(!selectedFlight?.parts?.multiple){
    delete selectedFlight?.parts?.multiple
  }

  return (
    <>
      <Grid item xs={12} md={8} className={classes.mainForm}>
        <Box
          mb={2.5}
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          className={classes.formHeader}
        >
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            className={classes.headerText}
          >
            <Typography variant="h1" align="center">
              Travel Care Service
            </Typography>
            <Typography variant="body1" align="center">
              Tickets at a good price are almost in your hands!
            </Typography>
          </Box>
        </Box>
        <Box className={classes.travelCareContainer}>
          <Box mb={4} display="flex" alignItems="center">
            <Box ml={2} mr={2}>
              <img src={TickIcon} alt="tick-icon" />
            </Box>
            <Typography variant="h2">Travel Care Service includes:</Typography>
          </Box>
          <Box>
            <Grid container spacing={1}>
              {travelCareData.map((item, idx) => (
                <Grid item xs={12} sm={6} key={idx}>
                  <TravelCareItem item={item} />
                </Grid>
              ))}
            </Grid>
          </Box>
        </Box>
      </Grid>
      <Grid
        // container
        item
        xs={12}
        md={4}
        className={classes.secondaryForm}
      >
        <Box className={classes.ticketCareBox}>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
          >
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              className={classes.ticketIconWrapper}
              mb={2}
            >
              <img src={TicketProtectionIcon} alt="ticket-protection" />
            </Box>
            <Typography variant="h3">Activate Ticket Protection</Typography>
            <Typography variant="body1" align="center">
              Don’t let unpleasant incidents spoil your trip, let us protect your journey! We are here to protect you from any problems you can occur during your flight.
            </Typography>
          </Box>
          <CustomRadio
            name="travelCare"
            defaultValue={apiData?.result?.travelCarePrice}
            travelCareValue={selectedFlight?.travelCarePrice}
            selectedFlight={selectedFlight}
            tipsValue={apiData?.result?.tips}
          />
          <Box mt={3} mb={3}>
            {!show && (
              <NextButton
                selectedFlight={selectedFlight}
                handleNext={() => {}}
                travelCareValue={selectedFlight?.travelCarePrice}
                disabled={true}
                location="form"
                tipsValue={0}
              />
            )}
          </Box>
        </Box>
        <Box width={1}>
          <FormOperator operatorInfo={apiData?.operatorInfo} />
          <Accreditation />
        </Box>
      </Grid>
    </>
  );
};

export default ThirdStepViewPage;
